<div class="vehicle-diagram" [class.vehicle-diagram--readonly]="readonly" (click)="onImageClick($event)">
    <img [src]="vehicleImage" alt="Diagrama del vehículo" class="vehicle-diagram-img">
    <button type="button" class="vehicle-diagram-pin" *ngFor="let p of points; let i = index"
        [style.left.%]="p.x" [style.top.%]="p.y" (click)="removePoint(i, $event)"
        [attr.title]="p.note || 'Daño registrado'">
    </button>
</div>
